export const VARS_KEYS = {
  IS_MAINTENANCE: 'IS_MAINTENANCE',
  IS_OUTBOUND_EMAIL_STOP: 'IS_OUTBOUND_EMAIL_STOP',
  FORMS_OF_PAYMENT: 'FORMS_OF_PAYMENT',
};

export const HEALTH_CHECK_TIME = 5000;
